var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcActiveBuzzerNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "pbw9f4mtra"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E98",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.758,
    fill: "#0D0D0D",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 21.15c1.308 0 2.391.974 2.556 2.23a7.037 7.037 0 0 1 3.005 2.269 6.841 6.841 0 0 1 1.41 4.18v4.174l1.67 3.322a.811.811 0 0 1-.035.794.821.821 0 0 1-.698.387H22.092a.821.821 0 0 1-.698-.387.812.812 0 0 1-.035-.794l1.67-3.322v-4.175a6.84 6.84 0 0 1 1.41-4.179 7.037 7.037 0 0 1 3.005-2.268A2.576 2.576 0 0 1 30 21.15zm9.9-2.911A13.787 13.787 0 0 1 44 28.08c0 .45-.367.816-.82.816a.818.818 0 0 1-.82-.816c0-3.282-1.286-6.368-3.62-8.689a.812.812 0 0 1 0-1.153.824.824 0 0 1 1.16 0zm-2.486 2.47a10.326 10.326 0 0 1 3.071 7.372c0 .45-.367.816-.82.816a.818.818 0 0 1-.82-.816 8.71 8.71 0 0 0-2.591-6.218.812.812 0 0 1 0-1.154.824.824 0 0 1 1.16 0zm-16.153-2.47c.32.318.32.835 0 1.153a12.172 12.172 0 0 0-3.62 8.69c0 .45-.368.815-.82.815A.818.818 0 0 1 16 28.08c0-3.718 1.456-7.213 4.1-9.842a.824.824 0 0 1 1.16 0zm2.485 2.47c.32.32.32.836 0 1.154a8.71 8.71 0 0 0-2.59 6.218c0 .45-.368.816-.821.816a.818.818 0 0 1-.82-.816c0-2.784 1.09-5.402 3.07-7.371a.824.824 0 0 1 1.16 0zM30 41.064a4.34 4.34 0 0 0 3.566-1.863h-7.132A4.34 4.34 0 0 0 30 41.063z",
    fill: "url(#pbw9f4mtra)",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveBuzzerNotification);
export default __webpack_public_path__ + "static/media/ic_active_buzzer_notification.4520a6f5cebcec0a02a37bcc470b7a73.svg";
export { ForwardRef as ReactComponent };